<template>
  <v-app>
    <v-app-bar app style="background-color: #FFFFFF; border-bottom: 1px solid #000000; padding-left: 16px; padding-right: 16px; box-shadow: none;">
      <img src="@/assets/logo-innogement-black-sinclaim.svg" style="height: 40px;" />
      <v-spacer></v-spacer>
      <span class="text-truncate" :style="{ maxWidth: ($vuetify.breakpoint.xs ? 200 : 500) + 'px' }">
        {{ recipientEmail }}
      </span>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main style="background-color: #f9f9f9;">

      <!-- Provides the application the proper gutter -->
      <v-container fluid>

        <!-- If using vue-router -->
        <keep-alive>
        <router-view></router-view>
        </keep-alive>
      </v-container>
    </v-main>

    <PageFooter />
  </v-app>
</template>

<script>
import PageFooter from './components/common/PageFooter';
// eslint-disable-next-line no-unused-vars
import styles from './assets/App.css'

export default {
  name: 'App',
  components: {
    PageFooter
  },
  data () {
    return {
    }
  },
  computed: {
    recipientEmail() {
      if (!this.$store.state.fundattio.formSubmissionInfo) {
        return '';
      }
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission.recipientEmail;
    }
  },
}
</script>
 